import {
    ApiBlueprint,
    coreExtensionData,
    createApiFactory,
    createExtension,
    createFrontendPlugin,
    discoveryApiRef,
    identityApiRef,
} from "@backstage/frontend-plugin-api";
import { AskjackClient } from "@internal/plugin-askjack-common";
import { AskjackRef, ChatWidget } from "@internal/plugin-askjack-react";

const askjackApiExtension = ApiBlueprint.make({
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: AskjackRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    identityApi: identityApiRef,
                },
                factory: ({ discoveryApi, identityApi }) =>
                    new AskjackClient({ discoveryApi, identityApi }),
            })
        ),
});

const chatWidgetExtension = createExtension({
    kind: "app-root-element",
    name: "chat-widget",
    attachTo: { id: "app/root", input: "elements" },
    output: [coreExtensionData.reactElement],
    factory: () => [coreExtensionData.reactElement(<ChatWidget />)],
});

export const askjackPlugin = createFrontendPlugin({
    pluginId: "askjack",
    extensions: [askjackApiExtension, chatWidgetExtension],
});
